// We are not importing these from getting-started-shared-tasks because we are
// wary of adding this dependency to every consumer of this library (especially
// to onboarding-tours).

export const IMPORT_YOUR_CONTACTS_TASK_KEY = 'import-contacts';
export const QUICK_IMPORT_CONTACTS_TASK_KEY = 'quick-import-contacts';
export const ADD_DATA_THROUGH_DATA_MODAL_TASK_KEY = 'add-data-modal';
export const IMPORT_DATA_ONBOARDING_TASKS = [IMPORT_YOUR_CONTACTS_TASK_KEY, QUICK_IMPORT_CONTACTS_TASK_KEY, ADD_DATA_THROUGH_DATA_MODAL_TASK_KEY];